var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBottom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8527 8.64582C16.0484 8.84073 16.0489 9.15731 15.854 9.35292L10.389 14.8374C10.1741 15.0531 9.82477 15.0531 9.60982 14.8374L4.14484 9.35292C3.94993 9.15731 3.95049 8.84073 4.1461 8.64582C4.34171 8.4509 4.65829 8.45147 4.85321 8.64708L9.99942 13.8117L15.1456 8.64708C15.3406 8.45147 15.6571 8.4509 15.8527 8.64582ZM15.8527 4.64582C16.0484 4.84073 16.0489 5.15731 15.854 5.35292L10.389 10.8374C10.1741 11.0531 9.82477 11.0531 9.60982 10.8374L4.14484 5.35292C3.94993 5.15731 3.95049 4.84073 4.1461 4.64582C4.34171 4.4509 4.65829 4.45147 4.85321 4.64708L9.99942 9.81166L15.1456 4.64708C15.3406 4.45147 15.6571 4.4509 15.8527 4.64582Z",
    fill: "#323130"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottom);
export default __webpack_public_path__ + "static/media/bottom.17cb7201ee49c4f51c2eb37bdf95ad1a.svg";
export { ForwardRef as ReactComponent };